var uiPagination = {
	caption: "Paginering",
	page: "Pagina {page}",
	first: "Eerste pagina",
	previous: "Vorige pagina",
	next: "Volgende pagina",
	last: "Laatste pagina"
};
var nl = {
	uiPagination: uiPagination
};

export { nl as default, uiPagination };
